function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "white",
  fillOpacity: 0.05
});
var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_20044474_131064)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.03116 4.73623C9.03593 4.36453 8.84035 4.01902 8.51922 3.8318C8.19808 3.64458 7.80105 3.64461 7.47995 3.83188C7.15884 4.01916 6.96332 4.36471 6.96815 4.7364C6.97548 5.30089 7.4352 5.75464 7.99974 5.75459C8.56428 5.75455 9.02393 5.30072 9.03116 4.73623ZM9.03116 11.2675C9.02388 10.703 8.5642 10.2492 7.99966 10.2492C7.43512 10.2492 6.97544 10.703 6.96815 11.2675C6.97544 11.832 7.43512 12.2858 7.99966 12.2858C8.5642 12.2858 9.02388 11.832 9.03116 11.2675ZM9.03116 8.00185C9.03593 7.63016 8.84035 7.28464 8.51922 7.09742C8.19808 6.9102 7.80105 6.91024 7.47995 7.09751C7.15884 7.28478 6.96332 7.63033 6.96815 8.00203C6.97548 8.56652 7.4352 9.02027 7.99974 9.02022C8.56428 9.02017 9.02392 8.56635 9.03116 8.00185Z",
  fill: "#C4C4C4"
}));
var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_20044474_131064"
}, /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 11,
  fill: "white",
  transform: "translate(2.5 2.5)"
})));
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.1cff2bd059e42fe774b10c8a84d047b2.svg";
export { ForwardRef as ReactComponent };